import { BsSearch } from "../../assets/icons/vander";

export const InputGroupSearch = ({
  placeholder,
  name,
  value,
  onInputChange,
  disabled,
  onSubmit,
}) => {
  return (
    <div className="input-group">
      <input
        type={`text`}
        className={`form-control`}
        placeholder={placeholder}
        name={name}
        value={value ?? ""}
        onChange={onInputChange}
      />
      <button
        className="btn btn-primary"
        type="button"
        disabled={disabled}
        onClick={onSubmit}
      >
        <BsSearch className="icons" />
      </button>
    </div>
  );
};
